class VersionInfo {
  constructor() {
    const na = "Not Available";
    this.loaded = false;
    this.versionInfo = {
      webVersion: na,
      customer: na,
      applicationType: na,
      migration: na,
      database: na,
      variation: na,
      companyName: na,
      isSSOAppSetup: false,
    };
    this.appearance = { displayName: "", logo1: "", logo2: "" };
    this.featureset = [];
    this.webConfigs = [];
  }
  isLoaded() {
    return this.loaded;
  }
  isSITE() {
    return this.versionInfo.applicationType === "SITE";
  }
  isTIMPS() {
    return this.versionInfo.applicationType === "TIMPS";
  }
  isLAMPDeprecated() {
    return this.versionInfo.applicationType === "LAMPDeprecated";
  }
  isLAMP() {
    return this.versionInfo.applicationType === "LAMP";
  }

  //ReVAMP
  isReVAMP() {
    return this.versionInfo.applicationType === "ReVAMP";
  }
  isEUtility() {
    return this.versionInfo.applicationType === "EUtility";
  }
  isBridge() {
    return this.versionInfo.variation === "Bridge";
  }
  isSSOAppSetup() {
    return this.versionInfo.isSSOAppSetup;
  }

  isChargeCodeField() {
    let featureset = this.featureset.find((f) => {
      return f.id === "addChargeCodeField";
    });

    return featureset && featureset.value === true ? true : false;
  }

  isDailyDisabled() {
    const dailyDisabledConfig = this.getWebConfig("dailyDisabled");
    return dailyDisabledConfig && dailyDisabledConfig.opt2 === true ? true : false;
  }

  isManualOOUEnabled() {
    const manualEnabledConfig = this.getWebConfig("enableManualOutOfUse");
    return manualEnabledConfig && manualEnabledConfig.opt2 === true ? true : false;
  }

  setVersionInfo(versionInfo) {
    this.versionInfo = versionInfo.versionInfo;
    this.featureset = versionInfo.featuresetList ? versionInfo.featuresetList : [];
    this.appearance = versionInfo.appearance ? versionInfo.appearance : { logo1: "", logo2: "" };
    this.webConfigs = versionInfo.webConfigs ? versionInfo.webConfigs : [];
  }
  getApplicationType() {
    return this.versionInfo.applicationType;
  }
  getWebVersion() {
    return this.versionInfo.webVersion;
  }
  getCustomer() {
    return this.versionInfo.customer;
  }

  getCustomerAbbr() {
    return customerAbbr[this.versionInfo.customer] ? customerAbbr[this.versionInfo.customer] : this.versionInfo.customer;
  }
  getMigration() {
    return this.versionInfo.migration;
  }
  getDatabase() {
    return this.versionInfo.database;
  }
  getCompanyName() {
    return this.versionInfo.companyName;
  }

  getFeatureset(id) {
    let featureset = this.featureset.find((f) => {
      return f.id === id;
    });
    return featureset;
  }

  getWebConfig(code) {
    return this.webConfigs.find((c) => c.code === code);
  }

  getVariation() {
    return this.versionInfo.variation;
  }
}

export const versionInfo = new VersionInfo();

export const getCustomer = () => versionInfo.getCustomer();
export const getCustomerAbbr = () => versionInfo.getCustomerAbbr();
export const getCompanyName = () => versionInfo.getCompanyName();
const customerAbbr = {
  "South Florida Regional Transportation Authority": "SFRTA",
  "Ontario Northland": "ONR",
  "Florida Gulf & Atlantic Railroad": "FGA",
  "Belt Railway of Chicago": "BRC",
  "Canadian Pacific": "CP",
  "Canadian National": "CN",
  TNW: "TNW",
  "Essex Terminal Railway": "ETR",
  Ferromex: "Ferromex",
  "Grenada Railroad": "GRYR",
  "New Orleans Public Belt": "NOPB",
  "New York, Susquehanna, and Western Railway (NYSW)": "NYSW",
  "Gulf and Ohio Railways": "GANDO",
  "Port Authority of NY & NJ": "PATH",
  "Texas North Western Railway": "TXNW",
  "Patriot Rail": "PATRIOT",
  "Southeastern Pennsylvania Transportation Authority": "SEPTA",
};

// todo: add all customers to following structure
export const SUPPORTED_CUSTOMERS = {
  CN: "Canadian National",
  ONR: "Ontario Northland",
};



// WEBPACK FOOTER //
// ./src/components/MainPage/VersionInfo.js